<template>
  <div class="page view_video">
	  <video controls autoplay>
      <source type="video/webm" :src="`/static/${video}.webm`">
      <source type="video/mp4" :src="`/static/${video}.mp4`">
	  </video>
  </div>
</template>

<script>

export default {
  name: 'video',
  components: {},
  props: {
    video: String
  },
  methods: {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  
  .view_video {

    display: flex;
    align-items: center;

	video {
		width: 100%;
	}
  }


</style>



// WEBPACK FOOTER //
// src/views/Video.vue